// Simple device ID utility with one fallback
export const getDeviceId = (): string | null => {
  const STORAGE_KEY = 'cpg_device_id';

  try {
    // Try to get existing device ID
    let deviceId = localStorage.getItem(STORAGE_KEY);

    if (!deviceId) {
      // Try to generate new UUID
      if (crypto && crypto.randomUUID) {
        deviceId = crypto.randomUUID();
      } else {
        // Fallback: timestamp + random
        deviceId = `${Date.now()}-${Math.random().toString(36).substring(2)}`;
      }

      localStorage.setItem(STORAGE_KEY, deviceId);
    }

    return deviceId;
  } catch (error) {
    console.warn('Failed to generate device ID:', error);
    return null;
  }
};

// Get device ID immediately
export const DEVICE_ID = getDeviceId();
